export default __webpack_public_path__ + "static/media/Vector (2).89f514c0.svg";